<template>
  <div class="news-press-releases">
    <div class="container mx-auto px-6 py-12">
      <h1 class="text-3xl font-bold mb-12 text-center text-gray-800">新闻资讯</h1>
      
      <div class="news-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="(news, index) in paginatedNews" :key="index" class="news-item group">
          <div class="news-image-wrapper overflow-hidden">
            <img :src="news.image" :alt="news.title" class="news-image w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105">
          </div>
          <div class="news-content pt-4">
            <div class="news-date text-gray-500 text-sm mb-2">{{ news.date }}</div>
            <h3 class="news-title text-xl font-semibold mb-3 text-gray-800 group-hover:text-blue-600 transition-colors">{{ news.title }}</h3>
            <p class="news-excerpt text-gray-600 mb-4 line-clamp-3">{{ news.excerpt }}</p>
            <a href="#" class="read-more text-blue-600 hover:underline font-medium inline-flex items-center">
              查看详情
              <i class="fas fa-arrow-right ml-1 transition-transform duration-300 group-hover:translate-x-1"></i>
            </a>
          </div>
        </div>
      </div>
      
      <!-- Pagination -->
      <div class="pagination mt-16 flex justify-center">
        <button 
          class="pagination-btn px-4 py-2 mx-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="currentPage === 1"
          @click="currentPage--"
        >
          上一页
        </button>
        <button 
          v-for="page in totalPages" 
          :key="page"
          class="pagination-btn px-4 py-2 mx-1 rounded-md border transition-colors duration-200"
          :class="currentPage === page ? 'bg-blue-600 text-white border-blue-600' : 'border-gray-300 text-gray-600 hover:bg-gray-50'"
          @click="currentPage = page"
        >
          {{ page }}
        </button>
        <button 
          class="pagination-btn px-4 py-2 mx-1 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="currentPage === totalPages"
          @click="currentPage++"
        >
          下一页
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';

const newsList = [
  {
    date: "2025-12-20",
    title: "北境骑团发布2025年度骑行趋势报告",
    excerpt: "报告显示，山地骑行和长途骑行成为2025年最受欢迎的骑行方式，北境骑团将推出多款新品满足市场需求。",
    image: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-11-15",
    title: "北境骑团与国际骑行联盟达成战略合作",
    excerpt: "双方将在骑行赛事、技术研发和市场推广等方面展开深度合作，共同推动全球骑行运动发展。",
    image: "https://images.unsplash.com/photo-1519052537078-e6302a4968d4?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-10-10",
    title: "北境骑团全新系列公路自行车正式发布",
    excerpt: "全新系列公路自行车采用最新碳纤维技术，轻量化设计，提供卓越的骑行体验，现已在全国各大门店上市。",
    image: "https://images.unsplash.com/photo-1507035895480-29c864a8824d?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-09-05",
    title: "北境骑团2025秋季骑行活动圆满结束",
    excerpt: "本次活动吸引了来自全国各地的2000余名骑行爱好者参与，共同体验骑行乐趣，感受北境骑团的品牌魅力。",
    image: "https://images.unsplash.com/photo-1551103782-8ab07afd45c1?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-08-20",
    title: "北境骑团荣获2025年度中国骑行品牌大奖",
    excerpt: "凭借卓越的产品质量和服务，北境骑团在众多品牌中脱颖而出，荣获2025年度中国骑行品牌大奖。",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-07-15",
    title: "北境骑团宣布拓展国际市场",
    excerpt: "北境骑团将正式进军欧洲和北美市场，计划在未来三年内开设50家海外门店，将中国骑行文化推向世界。",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-08-20",
    title: "北境骑团荣获2025年度中国骑行品牌大奖",
    excerpt: "凭借卓越的产品质量和服务，北境骑团在众多品牌中脱颖而出，荣获2025年度中国骑行品牌大奖。",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-07-15",
    title: "北境骑团宣布拓展国际市场",
    excerpt: "北境骑团将正式进军欧洲和北美市场，计划在未来三年内开设50家海外门店，将中国骑行文化推向世界。",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-08-20",
    title: "北境骑团荣获2025年度中国骑行品牌大奖",
    excerpt: "凭借卓越的产品质量和服务，北境骑团在众多品牌中脱颖而出，荣获2025年度中国骑行品牌大奖。",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=400&fit=crop&crop=entropy"
  },
  {
    date: "2025-07-15",
    title: "北境骑团宣布拓展国际市场",
    excerpt: "北境骑团将正式进军欧洲和北美市场，计划在未来三年内开设50家海外门店，将中国骑行文化推向世界。",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=400&fit=crop&crop=entropy"
  }
];

// Pagination
const currentPage = ref(1);
const pageSize = ref(6);

const totalPages = computed(() => {
  return Math.ceil(newsList.length / pageSize.value);
});

const paginatedNews = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return newsList.slice(start, end);
});
</script>

<style scoped>
.news-press-releases {
  background-color: #fafafa;
  min-height: calc(100vh - 80px);
}

/* News grid */
.news-grid {
  gap: 24px;
}

/* News item styling */
.news-item {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.news-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  border-color: #3b82f6;
}

/* News content */
.news-content {
  padding: 16px;
}

/* News date */
.news-date {
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
}

/* News title */
.news-title {
  color: #111827;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.news-item:hover .news-title {
  color: #3b82f6;
}

/* News excerpt */
.news-excerpt {
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Read more link */
.read-more {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  color: #3b82f6;
  text-decoration: none;
  transition: all 0.3s ease;
}

.read-more:hover {
  color: #2563eb;
  text-decoration: underline;
}

.read-more i {
  margin-left: 4px;
  transition: transform 0.3s ease;
}

.news-item:hover .read-more i {
  transform: translateX(3px);
}

/* Pagination */
.pagination {
  margin-top: 32px;
}

.pagination-btn {
  padding: 8px 16px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination-btn:hover:not(:disabled) {
  border-color: #1890ff;
  color: #1890ff;
}

.pagination-btn.active {
  background-color: #1890ff;
  border-color: #1890ff;
  color: #fff;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .news-title {
    font-size: 18px;
  }
  
  .news-content {
    padding: 12px;
  }
}
</style>